import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideIcons, provideNgIconsConfig } from '@ng-icons/core';
import {
  lucideActivity,
  lucideAlertTriangle,
  lucideArrowLeft,
  lucideArrowRight,
  lucideAward,
  lucideBan,
  lucideBell,
  lucideBellOff,
  lucideBriefcase,
  lucideBuilding,
  lucideCalendar,
  lucideCalendarOff,
  lucideCalendarPlus,
  lucideCamera,
  lucideCheck,
  lucideCheckCircle,
  lucideCheckCircle2,
  lucideChevronDown,
  lucideChevronRight,
  lucideClock,
  lucideCreditCard,
  lucideDollarSign,
  lucideDumbbell,
  lucideEye,
  lucideEyeOff,
  lucideHammer,
  lucideHome,
  lucideLayoutDashboard,
  lucideLogOut,
  lucideMail,
  lucideMapPin,
  lucideMenu,
  lucideMoon,
  lucideMoreHorizontal,
  lucidePackage,
  lucidePackageOpen,
  lucidePackagePlus,
  lucidePencil,
  lucidePhone,
  lucidePlus,
  lucideReceipt,
  lucideRefreshCw,
  lucideSearch,
  lucideSettings,
  lucideShield,
  lucideShieldAlert,
  lucideStar,
  lucideSun,
  lucideTag,
  lucideTrash,
  lucideTrash2,
  lucideTrendingUp,
  lucideUser,
  lucideUserCheck,
  lucideUserPlus,
  lucideUsers,
  lucideX,
  lucideXCircle,
  lucideLightbulb,
  lucideMessageSquare,
  lucideLoader,
  lucideSend,
} from '@ng-icons/lucide';

/**
 * Standard static icon registration matching https://ng-icons.github.io/ng-icons/
 * Providing both prefixed (lucideX) and direct/aliased names (x) for simple usage.
 */
export const appIcons = {
  // Lucide prefixed
  lucideActivity,
  lucideAlertTriangle,
  lucideArrowLeft,
  lucideArrowRight,
  lucideAward,
  lucideBan,
  lucideBell,
  lucideBellOff,
  lucideBriefcase,
  lucideBuilding,
  lucideCalendar,
  lucideCalendarOff,
  lucideCalendarPlus,
  lucideCamera,
  lucideCheck,
  lucideCheckCircle,
  lucideCheckCircle2,
  lucideChevronDown,
  lucideChevronRight,
  lucideClock,
  lucideCreditCard,
  lucideDollarSign,
  lucideDumbbell,
  lucideEye,
  lucideEyeOff,
  lucideHammer,
  lucideHome,
  lucideLayoutDashboard,
  lucideLogOut,
  lucideMail,
  lucideMapPin,
  lucideMenu,
  lucideMoon,
  lucideMoreHorizontal,
  lucidePackage,
  lucidePackageOpen,
  lucidePackagePlus,
  lucidePencil,
  lucidePhone,
  lucidePlus,
  lucideReceipt,
  lucideRefreshCw,
  lucideSearch,
  lucideSettings,
  lucideShield,
  lucideShieldAlert,
  lucideStar,
  lucideSun,
  lucideTag,
  lucideTrash,
  lucideTrash2,
  lucideTrendingUp,
  lucideUser,
  lucideUserCheck,
  lucideUserPlus,
  lucideUsers,
  lucideX,
  lucideXCircle,
  lucideLightbulb,
  lucideMessageSquare,
  lucideLoader,
  lucideSend,

  // Direct lowercase / camelCase aliases
  activity: lucideActivity,
  alertTriangle: lucideAlertTriangle,
  arrowLeft: lucideArrowLeft,
  arrowRight: lucideArrowRight,
  award: lucideAward,
  ban: lucideBan,
  bell: lucideBell,
  bellOff: lucideBellOff,
  briefcase: lucideBriefcase,
  building: lucideBuilding,
  calendar: lucideCalendar,
  calendarOff: lucideCalendarOff,
  calendarPlus: lucideCalendarPlus,
  camera: lucideCamera,
  check: lucideCheck,
  checkCircle: lucideCheckCircle,
  checkCircle2: lucideCheckCircle2,
  chevronDown: lucideChevronDown,
  chevronRight: lucideChevronRight,
  clock: lucideClock,
  creditCard: lucideCreditCard,
  dollarSign: lucideDollarSign,
  dumbbell: lucideDumbbell,
  eye: lucideEye,
  eyeOff: lucideEyeOff,
  hammer: lucideHammer,
  home: lucideHome,
  layoutDashboard: lucideLayoutDashboard,
  logOut: lucideLogOut,
  mail: lucideMail,
  mapPin: lucideMapPin,
  menu: lucideMenu,
  moon: lucideMoon,
  moreHorizontal: lucideMoreHorizontal,
  package: lucidePackage,
  packageOpen: lucidePackageOpen,
  packagePlus: lucidePackagePlus,
  pencil: lucidePencil,
  phone: lucidePhone,
  plus: lucidePlus,
  receipt: lucideReceipt,
  refreshCw: lucideRefreshCw,
  search: lucideSearch,
  settings: lucideSettings,
  shield: lucideShield,
  shieldAlert: lucideShieldAlert,
  star: lucideStar,
  sun: lucideSun,
  tag: lucideTag,
  trash: lucideTrash,
  trash2: lucideTrash2,
  trendingUp: lucideTrendingUp,
  user: lucideUser,
  userCheck: lucideUserCheck,
  userPlus: lucideUserPlus,
  users: lucideUsers,
  x: lucideX,
  xCircle: lucideXCircle,
  lightbulb: lucideLightbulb,
  'message-square': lucideMessageSquare,
  loader: lucideLoader,
  send: lucideSend,

  // Kebab-case aliases
  'alert-triangle': lucideAlertTriangle,
  'arrow-left': lucideArrowLeft,
  'arrow-right': lucideArrowRight,
  'bell-off': lucideBellOff,
  'calendar-off': lucideCalendarOff,
  'calendar-plus': lucideCalendarPlus,
  'check-circle': lucideCheckCircle,
  'check-circle-2': lucideCheckCircle2,
  'chevron-down': lucideChevronDown,
  'chevron-right': lucideChevronRight,
  'credit-card': lucideCreditCard,
  'dollar-sign': lucideDollarSign,
  'eye-off': lucideEyeOff,
  'layout-dashboard': lucideLayoutDashboard,
  'log-out': lucideLogOut,
  'map-pin': lucideMapPin,
  'more-horizontal': lucideMoreHorizontal,
  'package-open': lucidePackageOpen,
  'package-plus': lucidePackagePlus,
  'refresh-cw': lucideRefreshCw,
  'shield-alert': lucideShieldAlert,
  'trash-2': lucideTrash2,
  'trending-up': lucideTrendingUp,
  'user-check': lucideUserCheck,
  'user-plus': lucideUserPlus,
  'x-circle': lucideXCircle,
};

export function provideAppIcons(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideIcons(appIcons),
    provideNgIconsConfig({
      size: '1.25rem',
    }),
  ]);
}
